import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforoutstationinpune() {



  const cardData =
  {
    keyword: 'Bus Hire for Outstation in Pune ',
    heading: 'Sanavi Travels: Bus Hire for Outstation in Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus Hire for Outstation in Pune, providing safe, comfortable, and hassle-free transportation for families, corporate groups, schools, tour operators, and event organizers traveling outside Pune. Our fleet of well-maintained 20, 25, 30, 32, 35, 40, 45, and 50 seater buses is ideal for long-distance journeys, group tours, pilgrimages, destination weddings, and corporate outings, offering spacious seating, air-conditioned interiors, and ample luggage space for a comfortable travel experience. With experienced chauffeurs familiar with highway and outstation routes, flexible one-way and round-trip hire options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth, safe, and punctual journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport areas—to popular outstation destinations such as Mumbai, Shirdi, Mahabaleshwar, Nashik, Goa, Kolhapur, Aurangabad, and beyond, Sanavi Travels provides trusted outstation bus hire services in Pune for customers seeking comfort, safety, and reliable long-distance group transportation.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,





"services": [
    {
      "name": "Bus Hire for Outstation in Pune",
      "description": "Bus Hire for Outstation in Pune provides reliable and spacious buses for traveling to destinations outside Pune. Perfect for family trips, corporate outings, or group tours, these buses ensure comfort, safety, and timely arrivals. Experienced drivers navigate highways efficiently, making long-distance travel stress-free and enjoyable."
    },
    {
      "name": "Outstation Bus Rental Pune",
      "description": "Outstation Bus Rental Pune offers flexible rental options for trips beyond Pune. Vehicles are well-maintained, equipped with comfortable seating, and spacious interiors. Professional chauffeurs ensure safe driving and convenient stops, making long-distance journeys comfortable for all passengers."
    },
    {
      "name": "AC Outstation Bus Pune",
      "description": "AC Outstation Bus Pune provides air-conditioned buses for a cool and comfortable journey outside Pune. Ideal for summer travel or long distances, these buses allow passengers to relax while traveling with ample space for luggage and a smooth ride."
    },
    {
      "name": "Luxury Outstation Bus Hire Pune",
      "description": "Luxury Outstation Bus Hire Pune offers premium buses for long-distance travel. Equipped with plush seating, entertainment options, and spacious interiors, these buses provide a high-end travel experience for VIP guests, corporate groups, or family outings."
    },
    {
      "name": "Corporate Outstation Bus Pune",
      "description": "Corporate Outstation Bus Pune caters to office teams and business travelers planning trips outside Pune. Comfortable seating, professional drivers, and well-maintained buses ensure punctual, safe, and convenient transportation for corporate needs."
    },
    {
      "name": "Family Outstation Bus Pune",
      "description": "Family Outstation Bus Pune ensures safe and comfortable travel for families visiting destinations outside Pune. Spacious seating, luggage-friendly interiors, and professional drivers make it ideal for weekend trips, vacations, or multi-day journeys with children and seniors."
    },
    {
      "name": "Affordable Outstation Bus Pune",
      "description": "Affordable Outstation Bus Pune provides budget-friendly long-distance travel options without compromising on comfort or safety. Ideal for families, friends, or corporate groups seeking economical transport, these buses offer reliable service at competitive rates."
    },
    {
      "name": "Chauffeur Driven Outstation Bus",
      "description": "Chauffeur Driven Outstation Bus offers skilled drivers for hassle-free long-distance travel. Passengers can relax while the chauffeur manages routes, traffic, and timing efficiently. Perfect for group travel, corporate trips, and family vacations outside Pune."
    },
    {
      "name": "Group Travel Outstation Bus Pune",
      "description": "Group Travel Outstation Bus Pune is designed for large groups traveling beyond Pune. Spacious, comfortable, and well-equipped buses ensure a smooth journey, whether for corporate events, educational trips, or family tours. Professional drivers handle the journey efficiently and safely."
    },
    {
      "name": "Best Outstation Bus Service Pune",
      "description": "Best Outstation Bus Service Pune offers top-quality buses and professional service for superior long-distance travel. Comfortable interiors, experienced drivers, and attention to passenger convenience ensure a safe, reliable, and enjoyable journey outside Pune."
    },
    {
      "name": "Pune Outstation Bus Booking",
      "description": "Pune Outstation Bus Booking provides easy online and offline booking options for outstation buses. Flexible scheduling, transparent pricing, and reliable service make it convenient to plan trips to nearby cities, hill stations, or tourist destinations."
    },
    {
      "name": "Tourist Bus Hire Pune",
      "description": "Tourist Bus Hire Pune provides buses for sightseeing and long-distance tours outside Pune. Equipped for comfort and convenience, these buses ensure a pleasant travel experience for groups visiting popular destinations or offbeat locations."
    },
    {
      "name": "Long Distance Bus Pune",
      "description": "Long Distance Bus Pune offers dependable buses for intercity travel. Ideal for family vacations, corporate trips, or group tours, these buses provide spacious seating, professional drivers, and safe travel for long journeys."
    },
    {
      "name": "Weekend Trip Bus Pune",
      "description": "Weekend Trip Bus Pune is perfect for short getaways and weekend excursions outside Pune. Comfortable, spacious, and chauffeur-driven, these buses ensure a smooth journey and enjoyable travel experience for families, friends, or corporate groups."
    },
    {
      "name": "Travel Bus Pune",
      "description": "Travel Bus Pune provides reliable long-distance transportation for groups traveling from Pune to nearby cities, tourist spots, or hill stations. Well-maintained buses with professional drivers ensure safety, comfort, and punctuality throughout the journey."
    }
  ],
  "tableData": [
    ["Bus Hire for Outstation in Pune", "Outstation Bus Rental Pune"],
    ["AC Outstation Bus Pune", "Luxury Outstation Bus Hire Pune"],
    ["Corporate Outstation Bus Pune", "Family Outstation Bus Pune"],
    ["Affordable Outstation Bus Pune", "Chauffeur Driven Outstation Bus"],
    ["Group Travel Outstation Bus Pune", "Best Outstation Bus Service Pune"],
    ["Pune Outstation Bus Booking", "Tourist Bus Hire Pune"],
    ["Long Distance Bus Pune", "Weekend Trip Bus Pune"],
    ["Travel Bus Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Booking for Wedding in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable bus rental services for weddings in Pune, ideal for transporting guests in style and ensuring a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Buses",
    "WhyChoosedescription": "Travel in air-conditioned, well-maintained buses with ample seating and legroom, perfect for wedding guest transportation."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in Pune city and surrounding areas, ensuring safe, timely, and smooth transportation for all wedding guests."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for wedding bus bookings, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel planning, and last-minute changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored for wedding guest transportation in Pune."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for your guests."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for wedding bus bookings in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus booking services for weddings in Pune?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained buses for wedding guest transportation in Pune.'
  },
  {
    question: 'How can I book a bus for a wedding in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for wedding transportation?',
    answer: 'We provide a range of buses including mini, medium, and large capacity buses suitable for wedding guests of any size.'
  },
  {
    question: 'Are drivers included in the wedding bus rental?',
    answer: 'Yes, all bus rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the wedding bus service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the buses sanitized before trips?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the bus rental plan for a wedding?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your wedding requirements.'
  },
  {
    question: 'What payment options are available for wedding bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the wedding transportation?',
    answer: 'Yes, our 24x7 customer support team is available throughout your wedding travel.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'Booked buses for our wedding guests through Sanavi Travels. Very professional, clean buses, and timely service. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priyanka Kulkarni',
    feedback: 'Excellent service! Buses were comfortable, on-time, and the drivers were very courteous. Made our wedding guest transportation seamless.',
    rating: 5
  }
];


































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Outstation in Pune - Sanavi Travels",
  "description": "Bus hire for outstation trips in Pune by Sanavi Travels for family trips, corporate travel, weekend getaways, and tourist journeys. Choose AC and luxury buses for safe, comfortable, and affordable long-distance travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2180"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Bus Hire for Outstation in Pune Starting from ₹38 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for outstation trips in Pune with Sanavi Travels. AC and luxury buses for family trips, corporate travel, weekend getaways, and tourist journeys at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforoutstationinpune;